<template>
  <div
    class="wrapper"
  >
    <div class="before-slot slot">
      <slot name="before" />
    </div>
    <Viewer
      :key="product.id"
      class="viewer"
      :material="coinMaterial"
      :normals="coinNormals"
      :theme="collectionTheme"
    >
      <div
        class="circle"
        :class="circleClass"
      />
    </Viewer>
    <div class="after-slot slot">
      <slot />
    </div>
  </div>
</template>
<script>
import Viewer from '@/components/viewer/Viewer.vue';

export default {
  name: 'ViewerWrapper',
  components: {
    Viewer,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    collection() {
      if (!this.product || !this.product.collection) return null;
      const collectionId = Array.isArray(this.product.collection) ? this.product.collection[0] : this.product.collection;
      return this.$getCollectionById(collectionId);
    },

    collectionTheme() {
      return this.collection?.theme || null;
    },

    coinMaterial() {
      if (!this.product || !this.product.id) return null;
      // Determine material based on product id (e.g., "silver-20" starts with "silver")
      return this.product.shortId.startsWith('gold') ? 'gold' : 'silver';
    },

    coinNormals() {
      if (!this.product || !this.product.id) return null;
      return `${this.$store.state.staticAssetsPath}normalmaps/${this.collection.id}/${this.product.shortId}.jpeg`;
    },

    circleClass() {
      const theme = this.$currentTheme;
      const currentPage = this.$route.name;
      switch (currentPage) {
        case 'product':
          return `collections-${theme}-common-floral-produit`;
        case 'history':
          return 'common-floral-history';
        default:
          return 'common-cercle-home';
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.wrapper {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-areas: "before-slot viewer after-slot";
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  pointer-events: none;
  position: relative;

  +mobile() {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    grid-template-areas:
      "viewer"\
      "before-slot"\
      "after-slot";
  }

  & > .slot {
    justify-self: center;
    pointer-events: auto;
    +mobile() {
      justify-self: center;
      width: 100%;
      max-width: 600px;
    }
  }

  .before-slot {
    grid-area: before-slot;
  }

  .after-slot {
    grid-area: after-slot;
  }

  // +desktop() {
  //   background-image: radial-gradient(circle at center, rgba(0, 0, 0, 0.35) 0%, transparent 70%);
  //   background-size: 630px 631px;
  //   background-position: 40% 60%;
  //   background-repeat: no-repeat;
  // }


  .circle {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-size: cover;
    width: calc(var(--coin-viewer-size) + 6px);
    height: auto;
    z-index: 0;
  }

  .viewer {
    aspect-ratio: 1 / 1;
    width: var(--coin-viewer-size);
    height: auto;
    pointer-events: auto;
    z-index: 100;
    flex-shrink: 0;
    // align-self: cente
    justify-self: center;
    grid-area: viewer;
  }
}
</style>
